import { errorToast } from '@/utilities/toast.utilities';
import { MAX_TABLE_ROWS } from '@/main/app.constants';
import type {
  MaterializedTableFilterInput,
  MaterializedTableFormulaInput,
  MaterializedTablePropertyColumnInput,
} from '@/tableDefinitionEditor/materializedTable.types';
import { GET_MATERIALIZED_TABLE_QUERY } from '@/tableDefinitionEditor/materializedTable.types';
import { sqGraphQLApi } from '@/sdk/api/GraphQLApi';
import { sqConditionsApi } from '@/sdk/api/ConditionsApi';
import type { GraphQLOutputV1 } from '@/sdk/model/GraphQLOutputV1';
import type { GraphQLInputV1 } from '@/sdk/model/GraphQLInputV1';
import type { ConditionTableInputV1, TableResultOutputV1 } from '@/sdk/model/models';

export interface FetchMaterializedTableInput {
  tableDefinitionId: string;
  columnsToInclude?: string[];
  propertiesToInclude?: MaterializedTablePropertyColumnInput[];
  includeOverrides?: boolean;
  tableFormulas?: MaterializedTableFormulaInput[];
  cancellationGroup?: string;
  limit?: number;
  cursorKey?: string;
  filter?: MaterializedTableFilterInput;
}
export const fetchMaterializedTable = async ({
  tableDefinitionId,
  columnsToInclude,
  propertiesToInclude,
  includeOverrides,
  tableFormulas,
  cancellationGroup,
  limit,
  cursorKey,
  filter,
}: FetchMaterializedTableInput): Promise<GraphQLOutputV1> => {
  const inputObject: GraphQLInputV1 = {
    query: GET_MATERIALIZED_TABLE_QUERY,
    variables: {
      id: tableDefinitionId,
      limit: limit || MAX_TABLE_ROWS,
      columnsToInclude,
      propertiesToInclude,
      includeOverrides,
      tableFormulas,
      sorts: [],
      ...(cursorKey && {
        cursor: {
          cursorKey,
        },
      }),
      filter,
    },
  };
  try {
    const response = await sqGraphQLApi.graphql(inputObject, {
      cancellationGroup,
    });
    return response.data;
  } catch (e) {
    errorToast({ httpResponseOrError: e });
    return {};
  }
};

export interface ConditionTableStat {
  statistic: string;
  columnName?: string;
  itemId?: string;
}

export async function fetchConditionTableOverMaterializedTable(
  conditionTableInput: ConditionTableInputV1,
): Promise<TableResultOutputV1> {
  try {
    const response = await sqConditionsApi.conditionTable(conditionTableInput);
    return response.data;
  } catch (e) {
    errorToast({ httpResponseOrError: e });
    return {};
  }
}
